import { useQuery } from '@tanstack/react-query';
import { isNotNil } from 'ramda';
import { useSelector } from 'react-redux';

import { IRoom } from 'components/shared/Assets/shared/Form/Document/types';
import { PAGE_TYPE_PROPERTY } from 'constants/index';
import { ITarget, ITripEvent } from 'detailsv2/structure';
import { accountIdSelector } from 'store/user/selectors';
import axiosApi from 'utils/axios';
import { isDefined } from 'utils/ramda';

type AreaPage = ITarget;

type Props = {
  pageId?: number | string | null;
};

export const useAreaPageQuery = ({ pageId }: Props) => {
  const accountId = useSelector(accountIdSelector);

  const areaPageQueryRes = useQuery(
    ['area', accountId, pageId],
    () => axiosApi.get<AreaPage>(`/acc/${accountId}/pages/${pageId}`).then(({ data }) => data),
    { enabled: isDefined(pageId) },
  );

  return areaPageQueryRes;
};
